module.exports = __webpack_public_path__ + "static/media/knee-pain-copy.d29cef20.svg";